{% block swag_cms_extensions_block_behavior_config %}
    <div class="swag-cms-extensions-block-behavior-config">
        {% block swag_cms_extensions_block_behavior_config_rule %}
            <swag-cms-extensions-block-config-rule v-model:block="block" />
        {% endblock %}

        {% block swag_cms_extensions_block_behavior_config_quickview %}
            <swag-cms-extensions-block-config-quickview v-model:block="block" />
        {% endblock %}
    </div>
{% endblock %}
